import { Box } from "@chakra-ui/react";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import React from "react";
import { ContentHero } from "../styles";
import { ContentData } from "@types/common";

interface Props {
  heading: ContentData;
}

const Content: React.FC<Props> = ({ heading }) => {
  return (
    <Box my={10}>
      <ResponsiveContainer>
        <ContentHero
          dangerouslySetInnerHTML={{ __html: heading.data.heading }}
        />
      </ResponsiveContainer>
    </Box>
  );
};

export default Content;
